import Layout from '@/layout/index.vue'

export const MENU_ROUTE_CONFIG = {
  '/dashboard': { component: () => import('@/views/dashboard/dashboard.vue'), skipBackendAuth: true },
  '/report/list': { component: () => import('@/views/report/list/reportList.vue') },
  '/report/create': { component: () => import('@/views/report/create/reportCreate.vue') },
  '/report/detail': { component: () => import('@/views/report/detail/reportDetail.vue') },
  '/report/template': { component: () => import('@/views/report/template/reportTemplate.vue') },
  '/report/audit': { component: () => import('@/views/report/audit/reportAudit.vue') },
  '/report/export': { component: () => import('@/views/report/export/reportExport.vue') },
  '/system/notice': { component: () => import('@/views/system/notice/notice.vue') },
  '/system/log': { component: () => import('@/views/system/log/log.vue') },
  '/system/globalErrorLog': { component: () => import('@/views/system/globalErrorLog.vue') },
  '/system/logActivityStatistics': { component: () => import('@/views/system/logActivityStatistics.vue') },
  '/system/fullLog': { component: () => import('@/views/system/fullLog.vue') },
  '/system/user': { component: () => import('@/views/system/user/user.vue') },
  '/system/role': { component: () => import('@/views/system/role/role.vue') },
  '/system/dept': { component: () => import('@/views/system/dept/dept.vue') },
  '/system/auth': { component: () => import('@/views/system/auth/auth.vue') },
  '/reportModel/list': { component: () => import('@/views/reportModel/list/reportModelList.vue') },
  '/reportApply/reportApplyList': { component: () => import('@/views/reportApply/reportApplyList.vue') },
  '/reportApply/reportApplyWorkflow': { component: () => import('@/views/reportApply/reportApplyWorkflow.vue'), skipBackendAuth: true },
  '/reportApply/reportApplyAdmin': { component: () => import('@/views/reportApply/reportApplyAdmin.vue') },
  '/reportApply/reportOnlyOffice': { component: () => import('@/views/reportApply/reportOnlyOffice.vue'), skipBackendAuth: true },
  '/fxxk/itineraryList': { component: () => import('@/views/fxxk/itineraryList.vue') },
  '/feedback/feedbackPage': { component: () => import('@/views/feedback/feedbackPage.vue'), skipBackendAuth: true },
  '/feedback/feedbackAdmin': { component: () => import('@/views/feedback/feedbackAdmin.vue') }
}

export const MENU_COMPONENT_MAP = Object.keys(MENU_ROUTE_CONFIG).reduce((result, path) => {
  result[path] = MENU_ROUTE_CONFIG[path].component
  return result
}, {})

export const BACKEND_AUTH_FREE_ROUTES = Object.keys(MENU_ROUTE_CONFIG)
  .filter(path => MENU_ROUTE_CONFIG[path].skipBackendAuth)
  .map(path => ({
    path,
    name: path.replace(/^\//, '').replace(/\//g, '-'),
    component: MENU_ROUTE_CONFIG[path].component,
    meta: {
      title: MENU_ROUTE_CONFIG[path].title || '',
      skipBackendAuth: true
    }
  }))

export const BUILDING_COMPONENT = () => import('@/views/report/building/building.vue')

export function createRootLayoutRoute (children = []) {
  const mergedChildren = [...BACKEND_AUTH_FREE_ROUTES]
  children.forEach(child => {
    if (!mergedChildren.some(route => route.path === child.path)) mergedChildren.push(child)
  })
  // 优先重定向到第一个有真实页面的路由（在 MENU_COMPONENT_MAP 中有映射的），跳过 building 占位页
  const firstRealRoute = mergedChildren.find(child => child.path in MENU_COMPONENT_MAP)
  const firstChildPath = firstRealRoute ? firstRealRoute.path : (mergedChildren.length > 0 ? mergedChildren[0].path : '/404')
  return {
    path: '/',
    component: Layout,
    redirect: firstChildPath,
    children: mergedChildren
  }
}
